"use strict";

var Upload = React.createClass({
  getDefaultProps: function () {
    return {
      className: "",
      onFileSelected: function () {}
    };
  },
  onClick: function () {
    var inputFile = this.refs["inputFile"];
    inputFile.value = null;
    inputFile.click();
  },
  onFileSelected: function (event) {
    event.preventDefault();

    var files;
    if (event.dataTransfer) {
      files = event.dataTransfer.files;
    } else if (event.target) {
      files = event.target.files;
    }

    for(var i = 0; i < files.length; i++) {
      var file = files[i];

      file.extension = file.name.substr((~-file.name.lastIndexOf(".") >>> 0) + 2);

      this.props.onFileSelected(file);
    }
  },
  render: function() {
    return (
      <div className={"upload " + this.props.className}>
        <input type="file" className="file" title="" name="attachments[]" ref="inputFile" onChange={this.onFileSelected} multiple/>

        <div onClick={this.onClick} ref="customUploadButton">
          {this.props.children}
        </div>
      </div>
    );
  }
});


module.exports = Upload;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityInput/upload.jsx